/**
* DebugEvent.js
*
* @author Olivier van der Pool for Ranj
**/

export default class DebugEvent {
    constructor(type) {
        this.type = type;
    }
}

DebugEvent.SKIP_CONTENT = "DebugEvent.SKIP_CONTENT";


